import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { BaseResponse, SearchTableParam } from '@ui-components/models';

@Injectable({
  providedIn: 'root'
})
export class NumberingToolService {
  private loaderSubject = new BehaviorSubject<boolean>(false);
  showLoader$: Observable<boolean> = this.loaderSubject.asObservable();

  constructor(private http: HttpClient) { }

  public create(request: any) {
    this.loaderSubject.next(true);
    return this.http.post<any>("/DocumentNumber/Create", request).pipe(
      finalize(()=>{
        this.loaderSubject.next(false);
      })
    );
  }
  public update(request: any) {
    this.loaderSubject.next(true);
    return this.http.patch<BaseResponse<number>>("/DocumentNumber/Update", request).pipe(
      finalize(()=>{
        this.loaderSubject.next(false);
      }));
  }
  public getList(request: SearchTableParam<any>) {
    this.loaderSubject.next(true);
    return this.http.post<any>("/DocumentNumber/GetList", request).pipe(
      finalize(()=>{
        this.loaderSubject.next(false);
      }));
  }
  public getDepartments() {
    this.loaderSubject.next(true);
    const request = {
      username: localStorage.getItem('adUsername')
    };
    return this.http.post<BaseResponse<any>>(`/DocumentLoockups/GetAuthorizedDepartments`,request).pipe(
      finalize(()=>{
        this.loaderSubject.next(false);
      }));
  }
  public getManagementDepartments() {
    this.loaderSubject.next(true);
    return this.http.get<BaseResponse<any>>(`/DocumentLoockups/GetManagementDepartments`).pipe(
      finalize(()=>{
        this.loaderSubject.next(false);
      }));
  }
  public getAllCountries() {
    this.loaderSubject.next(true);
    return this.http.get<BaseResponse<any>>(`/DocumentLoockups/GetAllCountries`).pipe(
      finalize(()=>{
        this.loaderSubject.next(false);
      }));
  }
  public getEmployees() {
    this.loaderSubject.next(true);
    const request = {
      username: localStorage.getItem('adUsername'),
      authToken: JSON.parse(localStorage.getItem('coreToken'))
    };
    return this.http.post<BaseResponse<any>>(`/DocumentLoockups/GetEmployees`, request).pipe(
      finalize(()=>{
        this.loaderSubject.next(false);
      }));
  }
  public getUsersByParentUsername() {
    this.loaderSubject.next(true);
    const request = {
      username: localStorage.getItem('adUsername'),
      flagValue: false
    };
    return this.http.post<BaseResponse<any>>(`/DocumentLoockups/GetUsersByParentUsername`, request).pipe(
      finalize(()=>{
        this.loaderSubject.next(false);
      }));
  }
  public getUsersWithManagerByParentUsername() {
    this.loaderSubject.next(true);
    const request = {
      username: localStorage.getItem('adUsername'),
      flagValue: true
    };
    return this.http.post<BaseResponse<any>>(`/DocumentLoockups/GetUsersByParentUsername`, request).pipe(
      finalize(()=>{
        this.loaderSubject.next(false);
      }));
  }
  public getUserAndManager() {
    this.loaderSubject.next(true);
    const request = {
      username: localStorage.getItem('adUsername')
    };
    return this.http.post<BaseResponse<any>>(`/DocumentLoockups/GetUserAndManager`, request).pipe(
      finalize(()=>{
        this.loaderSubject.next(false);
      }));
  }
  public getClassifications() {
    this.loaderSubject.next(true);
    return this.http.get<BaseResponse<any>>("/DocumentLoockups/GetAllDocumentClassifications").pipe(
      finalize(()=>{
        this.loaderSubject.next(false);
      }));
  }
  public getUsers() {
    this.loaderSubject.next(true);
    return this.http.get<BaseResponse<any>>("/DocumentLoockups/GetAllUsers").pipe(
      finalize(()=>{
        this.loaderSubject.next(false);
      }));
  }
  public getDocumentTypes() {
    this.loaderSubject.next(true);
    return this.http.get<BaseResponse<any>>("/DocumentLoockups/GetAllDocumentTypes").pipe(
      finalize(()=>{
        this.loaderSubject.next(false);
      }));
  }
  public getCoreCompanyBranches() {
    this.loaderSubject.next(true);
    return this.http.get<BaseResponse<any>>("/EskaCoreIntegrationApi/GetCompanyBranches?companyId=1").pipe(
      finalize(()=>{
        this.loaderSubject.next(false);
      }));
  }
  public getAddresses() {
    this.loaderSubject.next(true);
    return this.http.get<BaseResponse<any>>("/UserAdress/GetAllAddresses").pipe(
      finalize(()=>{
        this.loaderSubject.next(false);
      }));
  }
  public get(id: string) {
    this.loaderSubject.next(true);
    return this.http.get<BaseResponse<any>>(`/DocumentNumber/Get?Id=${id}`).pipe(
      finalize(()=>{
        this.loaderSubject.next(false);
      }));
  }
  public delete(id: number) {
    this.loaderSubject.next(true);
    return this.http.get<BaseResponse<number>>(`/DocumentNumber/Delete?Id=${id}`).pipe(
      finalize(()=>{
        this.loaderSubject.next(false);
      }));
  }
  public getAll() {
    this.loaderSubject.next(true);
    return this.http.get<any[]>(`/DocumentNumber/GetAll`).pipe(
      finalize(()=>{
        this.loaderSubject.next(false);
      }));
  }
  public getUserLatestDocumentNo() {
    this.loaderSubject.next(true);
    return this.http.get<any>(`/DocumentNumber/GetUserLatestDocumentNo`).pipe(
      finalize(()=>{
        this.loaderSubject.next(false);
      }));
  }
}
